import { RNG } from "rot-js";
import { Actor } from "../actors/Actor";

const VOWEL_SET = {
  A: 10,
  E: 16,
  I: 9,
  O: 9,
  U: 5,

  S: 6,
  T: 6,
  D: 6,
  L: 6,
  N: 6,
};

const LETTER_SET = {
  A: 10, //57
  E: 16,
  I: 10,
  O: 9,
  U: 5,

  R: 12, //42
  S: 9,
  T: 12,
  L: 6,
  N: 6,

  C: 4, //17
  D: 5,
  H: 4,
  G: 4,

  B: 3, //12
  F: 3,
  M: 3,
  P: 3,

  J: 1, //9
  K: 1,
  W: 2,
  Y: 2,
  V: 1,
  X: 1,
  Z: 1,
  Q: 0,
};

export const VOWEL_POOL = Object.entries(VOWEL_SET).reduce(
  (result, [key, count]) => {
    for (let i = 0; i < count; i++) {
      result.push(key);
    }
    return result;
  },
  [] as string[]
);

export const LETTER_POOL = Object.entries(LETTER_SET).reduce(
  (result, [key, count]) => {
    for (let i = 0; i < count; i++) {
      result.push(key);
    }
    return result;
  },
  [] as string[]
);

export const fillWithLetters = (actor: Actor, max: number) => {
  for (let i = actor.spellWand.length; i < max; i++) {
    actor.spellWand.push(RNG.getItem(LETTER_POOL) || "");
  }
};

export const addLetters = (actor: Actor, count: number) => {
  const amount = Math.min(actor.maxLetters + 1, count + actor.spellWand.length);
  const vowelCount = actor.spellWand.reduce(
    (c, l) => (isVowel(l) ? c + 1 : c),
    0
  );
  if (vowelCount < 3) {
    const adjustedMin = Math.min(amount, actor.spellWand.length + 3);
    for (let j = actor.spellWand.length; j < adjustedMin; j++) {
      actor.spellWand.push(RNG.getItem(VOWEL_POOL) || "");
    }
  }

  for (let j = actor.spellWand.length; j < amount; j++) {
    actor.spellWand.push(RNG.getItem(LETTER_POOL) || "");
  }
};

export const isVowel = (ch: string) =>
  ch === "A" || ch === "E" || ch === "I" || ch === "O" || ch === "U";
